/* Homepage URA Fit presentation. No measurement, chart or product data is authored here. */
(function () {
 'use strict';
 if (window.URAFitHomeUnified) { window.URAFitHomeUnified.mount(document); return; }
 var instances = new Map();
 function clamp(n) { return Math.max(0, Math.min(1, n)); }
 function parse(node) { try { return JSON.parse(node.textContent); } catch (_) { return {}; } }
 function text(node, value) { if (node && node.textContent !== value) node.textContent = value; }
 function setup(kit) {
  if (instances.has(kit)) return;
  var title = document.getElementById('UraHomeFit-' + kit.dataset.section);
  var section = title && title.closest('.uhr-fit');
  var root = section && section.querySelector('[data-ufe][data-mode="home"]');
  var host = root && root.querySelector('[data-ufe-host]');
  if (!host) return;
  var abort = new AbortController(), signal = abort.signal;
  var reduced = matchMedia('(prefers-reduced-motion: reduce)');
  var mounted = false, destroyed = false, manual = false, enabled = false, wasOutside = false;
  var frame = 0, measureFrame = 0, resizeTimer = 0, lastProgress = -1, announced = '', outsideEdge = null;
  var stage, track, landing, heading, steps, chooser, toolbar, handoff, guideDock, copy;
  var sample = null, stickyTop = 0, available = 0, travel = 0, lastWidth = 0;
  var stableViewport = 0;
  var guide = section.querySelector('[data-ufrg-context="home"]');
  var restores = [], headerObserver, productLink, oldTone;
  function listen(target, name, fn, options) { target.addEventListener(name, fn, Object.assign({}, options, {signal:signal})); }
  function move(node, to) {
   if (!node) return;
   var anchor = document.createComment('ufe-unified-position');
   node.before(anchor); restores.push(function () { if (anchor.parentNode) anchor.replaceWith(node); }); to.append(node);
  }
  function send(active, progress, complete) { root.dispatchEvent(new CustomEvent('ura:fit-story', {detail:{active:active, progress:progress, complete:!!complete}})); }
  function parkGuide() {
   if (!mounted || !guide || guide.parentElement === guideDock) return;
   guideDock.append(guide); guide.removeAttribute('data-ufrg-mobile');
  }
  function values() {
   if (!sample) return null;
   var data = parse(sample.querySelector('[data-ufe-sample-data]'));
   var source = String(data.unit || '').toLowerCase();
   var factor = source === 'cm' ? 1 : /^(in|inch|inches)$/.test(source) ? 2.54 : 0;
   var selected = sample.querySelector('[data-ufe-unit][aria-pressed="true"]');
   var unit = selected ? selected.dataset.ufeUnit : 'in';
   if (!factor) return null;
   var arabic = String(document.documentElement.lang || '').toLowerCase().split('-')[0] === 'ar';
   var suffix = arabic ? (unit === 'in' ? 'بوصة' : 'سم') : unit;
   var result = {complete:true, progress:0};
   ['width','length'].forEach(function (kind, i) {
    var expected = Number(data[kind]) * factor / (unit === 'in' ? 2.54 : 1);
    var node = sample.querySelector('[data-ufe-value="' + kind + '"]');
    var valid = Number.isFinite(expected) && expected > 0 && node;
    var finished = valid && node.textContent.trim() === expected.toFixed(1) + ' ' + suffix;
    result.complete = result.complete && !!finished;
    var span = unit === 'in' ? 1 : 2.54;
    var actual = node ? parseFloat(node.textContent) : NaN;
    result.progress += (Number.isFinite(actual) ? clamp((actual - expected + span) / span) : 0) * (i ? .38 : .4);
   });
   if (result.complete) result.progress = 1;
   return result;
  }
  function phaseCopy(phase) {
   var control = sample && sample.querySelector('[data-ufe-control="' + phase + '"]');
   var label = control && control.querySelector('.ufe-sample-label strong');
   var help = control && control.querySelector('.ufe-sample-label small');
   return phase === 'result' ? {title:copy.size, help:sample && sample.querySelector('[data-ufe-story-result]') ? copy.resultHelp : copy.resultFallback}
    : {title:label ? label.textContent : '', help:help ? help.textContent : ''};
  }
  function present(phase) {
   if (phase === announced) return;
   section.dataset.ufeCinemaPhase = phase;
   announced = phase;
   var content = phaseCopy(phase);
   text(heading.querySelector('[data-ufe-cinema-title]'), content.title);
   text(heading.querySelector('[data-ufe-cinema-caption]'), content.help);
   text(heading.querySelector('.ufe-cinema-index'), (phase === 'width' ? '01' : phase === 'length' ? '02' : '03') + ' / 03');
   steps.querySelectorAll('[data-ufe-cinema-step]').forEach(function (step) {
    if (step.dataset.ufeCinemaStep === phase) step.setAttribute('aria-current','step'); else step.removeAttribute('aria-current');
   });
  }
  function completion() {
   var state = values(), complete = !!(state && state.complete);
   if (section.dataset.ufeCinemaComplete !== String(complete)) section.dataset.ufeCinemaComplete = String(complete);
   var size = sample && sample.querySelector('[data-ufe-story-result] > strong');
   if (size && size.getAttribute('aria-hidden') !== String(!complete)) size.setAttribute('aria-hidden', String(!complete));
   return state;
  }
  function mode() { section.dataset.ufeCinemaMode = !enabled ? 'static' : manual ? 'manual' : 'story'; }
  function reserveHeading() {
   section.style.removeProperty('--ufe-phase-height');
   var h = heading.querySelector('[data-ufe-cinema-title]'), p = heading.querySelector('[data-ufe-cinema-caption]');
   var beforeH = h.textContent, beforeP = p.textContent, maximum = 0;
   ['width','length','result'].forEach(function (phase) {
    var c = phaseCopy(phase); text(h,c.title); text(p,c.help);
    maximum = Math.max(maximum, heading.getBoundingClientRect().height);
   });
   text(h,beforeH); text(p,beforeP);
   section.style.setProperty('--ufe-phase-height', Math.ceil(maximum) + 'px');
  }
  function fixedAncestor(node) {
   for (var n = node; n && n !== document.body; n = n.parentElement) {
    if (/^(fixed|sticky)$/.test(getComputedStyle(n).position)) return true;
   }
   return false;
  }
  function measure() {
   measureFrame = 0; if (!mounted || destroyed || !sample) return;
   outsideEdge = null;
   var header = document.querySelector('[data-ura-header], .ura-header, .header-wrapper, .section-header, #shopify-section-header');
   var rect = header && header.getBoundingClientRect();
   stickyTop = Math.ceil(header && fixedAncestor(header) && rect.bottom > 0 ? Math.min(rect.bottom, 180) + 8 : 8);
   var vv = window.visualViewport, currentViewport = Math.min(innerHeight, vv ? vv.height : innerHeight);
   var coarse = matchMedia('(pointer:coarse)').matches;
   if (!coarse || !stableViewport || document.documentElement.clientWidth !== lastWidth) stableViewport = currentViewport;
   var viewport = coarse ? stableViewport : currentViewport;
   var safeBottom = viewport;
   document.querySelectorAll('[data-ura-app-dock-final], #PBarNextFrameWrapper, #PBarNextFrame').forEach(function (node) {
    var bounds = node.getBoundingClientRect(), style = getComputedStyle(node);
    var bottomBar = bounds.top >= viewport * .4 && bounds.height <= Math.min(180,viewport * .35);
    if (bottomBar && fixedAncestor(node) && style.display !== 'none' && style.visibility !== 'hidden' && bounds.height > 0 && bounds.bottom > 0 && bounds.top < viewport) {
     safeBottom = Math.min(safeBottom, Math.max(0,bounds.top));
    }
   });
   available = Math.floor(safeBottom - stickyTop - 12);
   lastWidth = document.documentElement.clientWidth;
   var focused = lastWidth <= 760;
   if (focused && toolbar.parentElement === stage) handoff.before(toolbar);
   else if (!focused && toolbar.parentElement !== stage) stage.insertBefore(toolbar,steps);
   section.setAttribute('data-ufe-measuring','');
   section.dataset.fitDensity = focused ? 'focused' : 'roomy';
   reserveHeading();
   var natural = Math.ceil(stage.getBoundingClientRect().height);
   if (!focused && natural > available) {
    section.dataset.fitDensity = 'compact'; reserveHeading(); natural = Math.ceil(stage.getBoundingClientRect().height);
   }
   var wasEnabled = enabled;
   section.dataset.ufePinReason = reduced.matches ? 'reduced-motion' : natural > available || available < 240 ? 'viewport-too-short' : root.dataset.ufeStoryReady !== 'true' ? 'sample-not-ready' : 'ready';
   section.style.setProperty('--ufe-cinema-available',available + 'px');
   enabled = !reduced.matches && natural <= available && available >= 240 && root.dataset.ufeStoryReady === 'true';
   travel = enabled ? Math.round(Math.max(450, Math.min(750, lastWidth < 750 ? 600 : natural * 1.3))) : 0;
   section.style.setProperty('--ufe-cinema-top', stickyTop + 'px');
   section.style.setProperty('--ufe-cinema-height', natural + 'px');
   section.style.setProperty('--ufe-cinema-travel', travel + 'px');
   section.removeAttribute('data-ufe-measuring'); mode(); parkGuide();
   if (!enabled && !manual) { send(false,1,true); announced = ''; present('result'); }
   else if (!wasEnabled && enabled) lastProgress = -1;
   schedule();
  }
  function scheduleMeasure() { if (!measureFrame) measureFrame = requestAnimationFrame(measure); }
  function draw() {
   frame = 0; if (!mounted || destroyed || !section.isConnected || document.hidden) return;
   var storyRect = track.getBoundingClientRect();
   var outside = storyRect.bottom <= stickyTop || storyRect.top >= innerHeight;
   if (outside) {
    wasOutside = true;
    if (enabled && !manual) {
     var edge = storyRect.bottom <= stickyTop ? 1 : 0;
     if (outsideEdge !== edge) {
      outsideEdge = edge; send(true,edge); lastProgress = -1;
      present(edge ? 'result' : 'width'); completion();
     }
    }
    return;
   }
   if (wasOutside) {
    wasOutside = false;
    outsideEdge = null;
    if (manual && enabled) {
     manual = false;
     root.dispatchEvent(new CustomEvent('ura:fit-story-resume'));
     mode(); lastProgress = -1;
    }
   }
   if (enabled && !manual) {
    var progress = clamp((stickyTop - storyRect.top) / Math.max(1,travel));
    var staged = progress < .36 ? clamp((progress-.06)/.18)*.4
     : progress < .70 ? .4 + clamp((progress-.42)/.16)*.38
     : .78 + clamp((progress-.74)/.08)*.22;
    if (Math.abs(progress-lastProgress) > .0002 || lastProgress < 0) {
     lastProgress = progress;
     send(true,staged);
     section.style.setProperty('--ufe-cinema-progress',String(progress));
     present(progress < .36 ? 'width' : progress < .70 ? 'length' : 'result');
    }
   }
   var state = completion();
   if (manual || !enabled) {
    var active = sample && sample.querySelector('[data-ufe-control].is-measuring');
    present(state && state.complete ? 'result' : active ? active.dataset.ufeControl : 'width');
    section.style.setProperty('--ufe-cinema-progress', String(state ? state.progress : 0));
   }
  }
  function schedule() { if (!document.hidden && !frame) frame = requestAnimationFrame(draw); }
  function sampleReady() {
   if (!mounted || destroyed) return;
   outsideEdge = null;
   sample = host.querySelector('[data-ufe-sample]'); if (!sample) return;
   var result = sample.querySelector('[data-ufe-story-result]'), controls = sample.querySelector('.ura4-fit__controls');
   if (result && controls && result.parentElement !== controls) {
    result.before(document.createComment('ufe-unified-result-position')); result.dataset.ufeUnifiedMoved = 'true'; controls.append(result);
   }
   var chosen = root.querySelector('[data-ufe-example][aria-pressed="true"]');
   if (chosen) text(chooser.querySelector('[data-ufe-cinema-garment]'), chosen.textContent);
   ['width','length'].forEach(function (kind) { text(steps.querySelector('[data-ufe-cinema-step="' + kind + '"] strong'), phaseCopy(kind).title); });
   section.dataset.ufeCinemaHasResult = String(!!result);
   announced = ''; lastProgress = -1; completion(); present('width'); scheduleMeasure();
  }
  function userOwns() {
   outsideEdge = null; manual = true; if (!mounted) return; mode(); announced = ''; schedule();
   // Track dimensions remain unchanged during replay. Later sections cannot jump.
  }
  function mount() {
   if (mounted || destroyed || !host.querySelector('[data-ufe-sample]')) return;
   var head = root.querySelector('.ufe-demo-head'), actions = root.querySelector('.ufe-demo-actions'), choices = root.querySelector('.ufe-garment-choices');
   if (!head || !actions || !choices) return;
   mounted = true; manual = root.dataset.ufeStoryManual === 'true';
   var fragment = kit.content.cloneNode(true); copy = parse(fragment.querySelector('[data-ufe-cinema-copy]'));
   Object.keys(copy).forEach(function (key) { if (typeof copy[key] === 'string') copy[key] = copy[key].replace(/&#39;|&#x27;|&apos;/gi,"'").replace(/&quot;/g,'"').replace(/&amp;/g,'&'); });
   heading = fragment.querySelector('.ufe-cinema-heading'); steps = fragment.querySelector('.ufe-cinema-chapters'); chooser = fragment.querySelector('.ufe-cinema-garments');
   landing = document.createElement('div'); landing.className = 'ufe-cinema-landing';
   track = document.createElement('div'); track.className = 'ufe-cinema-track';
   stage = document.createElement('div'); stage.className = 'ufe-cinema-stage';
   toolbar = document.createElement('div'); toolbar.className = 'ufe-cinema-toolbar';
   handoff = document.createElement('div'); handoff.className = 'ufe-cinema-handoff';
   guideDock = document.createElement('div'); guideDock.className = 'ufe-cinema-guide';
   root.before(guideDock); root.prepend(landing,track); track.append(stage);
   move(section.querySelector('.ura-fit-intro__copy'),landing); move(head,stage); stage.append(heading); move(host,stage);
   toolbar.append(chooser); move(choices,chooser); move(actions,toolbar); stage.append(toolbar,steps);
   root.append(handoff); move(root.querySelector('.ufe-demo-note'),handoff);
   productLink = root.querySelector('[data-ufe-product-link]');
   if (productLink) { oldTone = productLink.getAttribute('data-ucj-tone'); productLink.dataset.ucjTone = 'dark'; move(productLink,handoff); }
   if (guide) move(guide,guideDock);
   section.dataset.ufeCinema = 'ready'; section.dataset.ufeLayout = 'joined'; section.dataset.ufeView = 'unified';
   section.removeAttribute('data-journey-pinned'); section.style.removeProperty('height');
   sampleReady();
   if ('ResizeObserver' in window) {
    headerObserver = new ResizeObserver(scheduleMeasure);
    document.querySelectorAll('[data-ura-header], .ura-header, [data-ura-app-dock-final], #PBarNextFrameWrapper, #PBarNextFrame').forEach(function(node){headerObserver.observe(node);});
   }
  }
  var mutations = new MutationObserver(function (records) {
   if (!mounted) { mount(); return; }
   if (host.querySelector('[data-ufe-sample]') !== sample) sampleReady();
   if (guide && records.some(function (r) { return Array.from(r.addedNodes).includes(guide); })) parkGuide();
   if (manual || !enabled) schedule();
  });
  mutations.observe(section,{childList:true,subtree:true});
  listen(root,'ura:fit-story-ready',function () { if (!mounted) mount(); else sampleReady(); });
  listen(root,'ura:fit-story-interaction',userOwns);
  listen(window,'scroll',schedule,{passive:true});
  function resized() {
   if (!mounted) return;
   if (matchMedia('(pointer:coarse)').matches && document.documentElement.clientWidth === lastWidth) { schedule(); return; }
   stableViewport = 0;
   clearTimeout(resizeTimer); resizeTimer = setTimeout(scheduleMeasure,120);
  }
  listen(window,'resize',resized,{passive:true});
  if (window.visualViewport) listen(window.visualViewport,'resize',resized,{passive:true});
  listen(window,'orientationchange',function () { stableViewport = 0; clearTimeout(resizeTimer); resizeTimer = setTimeout(scheduleMeasure,120); }); listen(window,'pageshow',function () { stableViewport = 0; scheduleMeasure(); });
  listen(reduced,'change',scheduleMeasure);
  listen(document,'visibilitychange',function () { if (!document.hidden) { lastProgress = -1; schedule(); } });
  listen(section,'keydown',function (event) { if (event.key === 'Escape' && chooser && chooser.open) { chooser.open = false; chooser.querySelector('summary').focus({preventScroll:true}); } });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { if (!destroyed) scheduleMeasure(); });
  instances.set(kit,function () {
   destroyed = true; abort.abort(); mutations.disconnect(); if (headerObserver) headerObserver.disconnect();
   cancelAnimationFrame(frame); cancelAnimationFrame(measureFrame); clearTimeout(resizeTimer); send(false,1,true);
   if (sample) {
    var result = sample.querySelector('[data-ufe-unified-moved]');
    if (result) {
     var walker = document.createTreeWalker(sample,NodeFilter.SHOW_COMMENT), anchor;
     while ((anchor = walker.nextNode())) if (anchor.data === 'ufe-unified-result-position') { anchor.replaceWith(result); break; }
     result.removeAttribute('data-ufe-unified-moved'); var size = result.querySelector('strong'); if (size) size.removeAttribute('aria-hidden');
    }
   }
   if (productLink) { if (oldTone === null) productLink.removeAttribute('data-ucj-tone'); else productLink.setAttribute('data-ucj-tone',oldTone); }
   restores.reverse().forEach(function (restore) { restore(); });
   [landing,track,toolbar,guideDock,handoff].forEach(function (node) { if (node) node.remove(); });
   ['ufe-cinema','ufe-layout','ufe-view','ufe-cinema-mode','ufe-cinema-phase','ufe-cinema-has-result','ufe-cinema-complete','fit-density','ufe-measuring','ufe-pin-reason'].forEach(function (key) { section.removeAttribute('data-' + key); });
   ['top','height','travel','progress','available'].forEach(function (key) { section.style.removeProperty('--ufe-cinema-' + key); });
   section.style.removeProperty('--ufe-phase-height'); instances.delete(kit);
  });
  mount();
 }
 function mountAll(scope) { scope.querySelectorAll('template[data-ufe-unified-kit]').forEach(setup); }
 window.URAFitHomeUnified = {mount:mountAll};
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { mountAll(document); },{once:true}); else mountAll(document);
 document.addEventListener('shopify:section:load',function (event) { mountAll(event.target); });
 document.addEventListener('shopify:section:unload',function (event) { instances.forEach(function (dispose,kit) { if (event.target.contains(kit)) dispose(); }); });
}());


